import React, { Component } from "react";
import map from "lodash/map";
import reject from "lodash/reject";
import { Modal, Button, message, Popconfirm, Select, Radio, Space } from "antd";
import * as yup from "yup";
import american_express_dark from "../../../../Assets/images/BankAccountImage.svg";
import visa_dark from "../../../../Assets/images/useraccount/visa_dark.svg";
import peeking_doodle from "../../../../Assets/images/useraccount/peeking_doodle.svg";
import { filter, uniqBy } from "lodash";
import AddAddress from "../../../Common/AddAddress";
import { createCustomerInstax } from "../../../../Actions/userAccounts";
const { Option } = Select;
const payment_methods = [
  { id: "0", key: "", value: "Select" },
  { id: "1", key: "credit_card", value: "Credit Card" },
  { id: "2", key: "ach", value: "ACH Payment" },
];

class BillingInfo extends Component {
  fattJs = null;

  constructor(props) {
    super(props);
    this.state = {
      is_edit_info: false,
      can_edit: true,
      loader: false,
      is_btn_active: false,
      card_list: [],
      ServiceData: [],
      card_details: {},
      card_address: {},
      card_holder_name: "",
      stax_customer: "",
      first_name: "",
      last_name: "",
      email: "",
      card_number: "",
      card_expiry_month: "",
      card_expiry_year: "",
      card_cvv: "",
      errors: {},
      role: "",
      billing_addresses: [],
      showAddAddressView: false,
      addresses: [],
      payment_method: "",
      bank_name: "",
      routing_number: "",
      account_holder_name: "",
      account_number: "",
      account_type: "",
      bank_holder_type: "",
    };
  }

  componentDidMount = () => {
    const userKey = JSON.parse(localStorage.getItem("userKey")) || null;
    this.setState({ loader: true });
    // Get All card list
    this.props.getCardList();

    // Get All service address
    this.props.getServiceOrder(userKey?.user?.uuid);

    // Get billing info
    this.props.getBillingInfo(userKey?.user?.uuid);

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);

    if (userKey) {
      this.setState({ role: userKey?.user?.role });
    }

    //Set user properties
    this.setState({
      stax_customer:
        this.props && this.props.AccountInfo
          ? this.props.AccountInfo.data.stax_customer
          : null,
      first_name:
        this.props && this.props.AccountInfo
          ? this.props.AccountInfo.data.first_name
          : null,
      last_name:
        this.props && this.props.AccountInfo
          ? this.props.AccountInfo.data.last_name
          : null,
      email:
        this.props && this.props.AccountInfo
          ? this.props.AccountInfo.data.email
          : null,
      stax_public_apikey:
        this.props &&
        this.props.AccountInfo &&
        this.props.AccountInfo.data.field_office
          ? this.props.AccountInfo.data.field_office.stax_public_apikey
          : null,
    });
  };

  UNSAFE_componentWillReceiveProps = (props) => {
    let { card_list, billing_addresses } = this.state;

    // get card list
    if (
      Object.keys(props.getCard.data).length > 0 &&
      props.getCard.data !== this.props.getCard.data
    ) {
      this.setState(
        {
          card_list: props.getCard.data.results,
        },
        () => {
          // console.warn('card_list - 1', this.state.card_list);
        }
      );
    }
    if (
      Object.keys(props.getCard.data).length > 0 &&
      props.getCard.data !== this.props.getCard.data
    ) {
      // display error messsage
    }

    // Service Order details
    if (
      Object.keys(props.serviceOrder.data).length > 0 &&
      props.serviceOrder.data !== this.props.serviceOrder.data
    ) {
      this.setState({
        ServiceData: props.serviceOrder.data.results,
      });
    }

    // Get service order enquiry details
    if (
      Object.keys(props.enquiry.data).length > 0 &&
      props.enquiry.data !== this.props.enquiry.data
    ) {
      this.setState({
        ServiceData: props.enquiry.data.results,
      });
    }

    if (
      Object.keys(props.serviceOrder.errors).length > 0 &&
      props.serviceOrder.errors !== this.props.serviceOrder.errors
    ) {
      // display error messsage
    }

    // Get billing info
    if (
      Object.keys(props.BillingInfo.data).length > 0 &&
      props.BillingInfo.data !== this.props.BillingInfo.data
    ) {
      this.setState({
        billing_addresses: props.BillingInfo.data,
      });
    }

    if (
      Object.keys(props.BillingInfo.errors).length > 0 &&
      props.BillingInfo.errors !== this.props.BillingInfo.errors
    ) {
      // display error messsage
    }

    // Add new card
    if (
      Object.keys(props.newCard.data).length > 0 &&
      props.newCard.data !== this.props.newCard.data
    ) {
      card_list.push(props.newCard.data);
      this.setState({
        is_edit_info: false,
        card_holder_name: "",
        card_address: {},
        card_list,
      });
    }

    if (
      Object.keys(props.newCard.errors).length > 0 &&
      props.newCard.errors !== this.props.newCard.errors
    ) {
      // display error messsage
    }

    // Delete new card
    if (
      Object.keys(props.cardDeleted.errors).length > 0 &&
      props.cardDeleted.errors !== this.props.cardDeleted.errors
    ) {
      // display error messsage
      this.props.getCardList();
      message.error(
        props.cardDeleted.errors && props.cardDeleted.errors.message
      );
    }

    // Update card
    if (
      Object.keys(props.updatedCard.data).length > 0 &&
      props.updatedCard.data !== this.props.updatedCard.data
    ) {
      // Get All card list
      this.props.getCardList();
      this.setState({
        is_edit_info: false,
      });
    }

    if (
      Object.keys(props.updatedCard.errors).length > 0 &&
      props.updatedCard.errors !== this.props.updatedCard.errors
    ) {
      // display error messsage
    }

    this.setState({ loader: false });
  };

  //Set service Address
  serviceAddressCheck = (e, item) => {
    let { card_address } = this.state;

    if (e.target.checked) {
      Object.assign(card_address, {
        uuid: item.uuid,
        address: item.address,
        city: item.city,
        state: item.state,
        zip_code: item.zip_code,
      });

      this.setState({ card_address });
    }
  };

  // toggle add address view
  toggleAddAddress = (value) => {
    this.setState({ showAddAddressView: value });
  };

  // on add address
  onAddAddress = (obj) => {
    const { addresses } = this.state;
    addresses.push({
      billing_addresses: { uuid: (Math.random() * 10).toString(), ...obj },
    });
    this.setState({ addresses });
  };

  //render service address
  renderServiceOrder = () => {
    let { billing_addresses, card_address, addresses } = this.state;

    return map(billing_addresses, (item, i) => {
      if (item.address) {
        return (
          <div className="checkbox_wrapper" key={i}>
            <input
              type="radio"
              name="address"
              checked={card_address?.uuid === item?.uuid}
              id={`address${i}`}
              onChange={(e) => {
                this.serviceAddressCheck(e, item);
              }}
            />
            <label htmlFor={`address${i}`}>
              {item.address ? item.formatted_address : ""}
            </label>
          </div>
        );
      }
    });
  };

  // render commercial service order
  renderCommercialServiceOrder = () => {
    let { billing_addresses, card_address, addresses } = this.state;

    let addressList = [];
    // filter(billing_addresses,(obj) => obj.is_billing_address_same ? addressList.push({...obj.service_address}) : addressList.push({...obj.billing_address}) );
    addressList.push(...billing_addresses);
    addresses.forEach((each) => {
      addressList.push(each.billing_addresses);
    });
    addressList = uniqBy([...addressList], "uuid");

    return map(addressList, (item, i) => {
      return (
        <div className="checkbox_wrapper" key={i}>
          <input
            type="radio"
            name="address"
            checked={card_address?.uuid === item?.uuid}
            id={`address${i}`}
            onChange={(e) => {
              this.serviceAddressCheck(e, item);
            }}
          />
          {/* <label htmlFor={`address${i}`}>
            {`${item.formatted_address}`}
          </label> */}
          <label htmlFor={`address${i}`} className="fitem-ck-txt">
            {`${item.address}, ${item.city}, ${item.state}, ${item.zip_code} `}
          </label>
        </div>
      );
    });
  };

  //renderCard List
  renderCardList = () => {
    let { card_list } = this.state;
    console.log("card_list", card_list);
    var isDefault = false;
    return map(card_list, (item, i) => {
      return (
        <div className="col-md-4" key={i}>
          <div className="service_card billing_card">
            <div className="body">
              <div className="card_details">
                <div className="card_img">
                  {JSON.parse(item.stax_payment_object).card_type === "visa" ? (
                    <img src={visa_dark} alt="" />
                  ) : (
                    <img src={american_express_dark} alt="" />
                  )}
                </div>
                {item?.is_ach ? (
                  <div className="card_number">
                    <label>
                      ACH Ending XXXX{" "}
                      {JSON.parse(item.stax_payment_object) &&
                        JSON.parse(item.stax_payment_object).card_last_four}
                    </label>
                    {/* <span>Exp {JSON.parse(item.stax_payment_object).card_exp.toString().slice(0,2)}/{JSON.parse(item.stax_payment_object).card_exp.toString().slice(2,6)} */}
                    {/* </span> */}
                  </div>
                ) : (
                  <div className="card_number">
                    <label>
                      Visa ending in{" "}
                      {JSON.parse(item.stax_payment_object) &&
                        JSON.parse(item.stax_payment_object).card_last_four}
                    </label>
                    <span>
                      Exp{" "}
                      {JSON.parse(item.stax_payment_object)
                        .card_exp.toString()
                        .slice(0, 2)}
                      /
                      {JSON.parse(item.stax_payment_object)
                        .card_exp.toString()
                        .slice(2, 6)}
                    </span>
                  </div>
                )}
              </div>
              <div className="address">
                <label>Billing Address</label>
                <p className="mb-0"> {item.card_holder_name}</p>
                {item.address ? (
                  <p>
                    {item.address.address},<br />
                    {item.address.city},<br />
                    {item.address.state}, {item.address.zip_code}
                    <br />
                  </p>
                ) : (
                  ""
                )}
              </div>
              {isDefault = item?.is_ach ? item?.charge_invoice_ach : item?.charge_invoice_card}
              {isDefault && (
                <div className="default_payment">
                  <label>Default payment for</label>
                  <span>
                    {item.address !== null && (
                      <p>
                        {item.address.address},<br />
                        {item.address.city},<br />
                        {item.address.state}, {item.address.zip_code}
                        <br />
                      </p>
                    )}
                  </span>
                </div>
              )}
              <div className="bill_action">
                <Popconfirm
                  title={
                    item?.is_ach
                      ? "Are you sure delete this payment method?"
                      : "Are you sure delete this card?"
                  }
                  onConfirm={() => {
                    this.props.deleteCard(item.uuid);
                    this.setState({ loader: true });
                    this.setState({
                      card_list: reject(card_list, function (el) {
                        return el.uuid === item.uuid;
                      }),
                    });
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <span>Delete</span>
                </Popconfirm>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  // Add New Card
  addNewCard = () => {
    const {
      card_address,
      card_holder_name,
      stax_customer,
      first_name,
      last_name,
      email,
      card_number,
      card_expiry_month,
      card_expiry_year,
    } = this.state;

    let user = JSON.parse(localStorage.getItem("userKey"))
      ? JSON.parse(localStorage.getItem("userKey")).user
      : "";

    this.setState({ loader: true });

    const token_obj = {
      address_1: card_address.address || null,
      address_city: card_address.city || null,
      address_state: card_address.state || null,
      address_zip: card_address.zip_code || null,
      month: card_expiry_month || null,
      year: card_expiry_year || null,
      card_number: card_number || null,
      email: email || null,
      firstname: first_name || null,
      lastname: last_name || null,
      method: "card",
      person_name: card_holder_name || null,
      customer_id: stax_customer || null,
    };

    this.fattJs
      .tokenize(token_obj)
      .then((res) => {
        if (res && Object.keys(res).length > 0) {
          this.props.addNewCard({
            user_uuid: user.uuid || null,
            address: card_address || null,
            stax_card_token: res["id"] || null,
            card_holder_name: card_holder_name || null,
            charge_invoice_card: true,
            location: "website"
          });
          setTimeout(() => {
            this.setState({
              loader: false,
              payment_method: "",
              card_holder_name: "",
              card_expiry_month: "",
              card_expiry_year: "",
              card_number: "",
              card_cvv: "",
            });
          }, 3500);
        } else {
          this.setState({ loader: false });
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        map(err.fieldErrors, (item) => {
          message.error(item.message, 10);
        });
      });
  };

  addNewACHcard = async () => {
    const {
      account_number,
      routing_number,
      bank_holder_type,
      account_type,
      account_holder_name,
      card_address,
      addresses,
      email,
      first_name,
      last_name,
    } = this.state;

    let user = JSON.parse(localStorage.getItem("userKey"))
      ? JSON.parse(localStorage.getItem("userKey")).user
      : "";

    this.setState({ loader: true });

    let fattJs = this.fattJs;

    const token_obj = {
      address_1: card_address?.address,
      address_2: card_address?.address2,
      address_city: card_address?.city,
      address_state: card_address?.state,
      address_zip: card_address.zip_code,
      email: email || "",
      firstname: first_name || "",
      lastname: last_name || "",
      person_name: `${first_name} ${last_name}`,
    };
    const id = await createCustomerInstax(token_obj);
    const ach_data = {
      method: "bank",
      person_name: account_holder_name || "",
      bank_account: account_number || "",
      bank_routing: routing_number || "",
      bank_holder_type: bank_holder_type || "",
      bank_type: account_type || "",
      customer_id: id,
    };

    fattJs
      .tokenize(ach_data)
      .then((res) => {
        if (res && Object.keys(res).length > 0) {
          this.props.addNewCard({
            user_uuid: user.uuid,
            stax_card_token: res["id"] || null,
            address: card_address,
            card_holder_name: account_holder_name || "",
            charge_invoice_ach: true,
            location: "website",
          });
          this.setState({
            errors: {},
            is_edit_info: false,
            loader: false,
            bank_name: "",
            routing_number: "",
            account_holder_name: "",
            account_number: "",
            account_type: "",
            bank_holder_type: "",
            payment_method: "",
          });
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        map(err.fieldErrors, (item) => {
          message.error(item.message, 10);
        });
        message.error(err.message, 10);
      });
  };

  // Update New card
  UpdateCard = () => {
    let user = JSON.parse(localStorage.getItem("userKey")) || null;
    let { card_holder_name, card_address, temp_card, updateCard } = this.state;
    this.setState({ loader: true });
    this.props.UpdateCard({
      user_uuid: user?.user?.uuid,
      uuid: temp_card.uuid,
      address: card_address,
      stripe_card_details: updateCard.stripe_card_details,
      card_holder_name: card_holder_name,
    });
  };

  handleValidate = () => {
    let { payment_method } = this.state;
    if (payment_method === "credit_card") {
      this.cardValidation();
    } else {
      this.achValidation();
    }
  };

  // card validation
  cardValidation = () => {
    const {
      card_holder_name,
      card_address,
      card_number,
      card_expiry_month,
      card_expiry_year,
      card_cvv,
    } = this.state;

    setTimeout(() => {
      const cardSchema = yup.object().shape({
        card_number: this.fattJs.validNumber
          ? null
          : yup.string().nullable().required("Card Number is required"),
        card_expiry_month: yup
          .string()
          .nullable()
          .required("Expire Month is required"),
        card_expiry_year: yup
          .string()
          .nullable()
          .required("Expire Year is required")
          .min(4, "Card expire year is invalid.")
          .max(4, "Card expire year is invalid."),
        card_cvv: this.fattJs.validCvv
          ? null
          : yup.string().nullable().required("CVV is required"),
        card_address: yup.object().shape({
          address: yup.string().required("Address is required"),
          state: yup.string().required("State is required"),
          city: yup.string().required("City is required"),
          zip_code: yup.string().required("Zipcode is required"),
        }),
        card_holder_name: yup.string().required("Card holder name is required"),
      });

      const cardData = {
        card_holder_name,
        card_address,
        card_number,
        card_expiry_month,
        card_expiry_year,
        card_cvv,
      };
      cardSchema
        .validate(cardData, { abortEarly: false })
        .then(() => {
          this.setState({ errors: {}, is_btn_active: true });
          this.addNewCard();
        })
        .catch((error) => {
          let err_data = {};
          map(error.inner, (item) => {
            err_data[item.path] = item.message;
          });
          this.setState({ errors: err_data, is_btn_active: false });
        });
    }, 500);
  };

  achValidation = () => {
    const {
      bank_name,
      routing_number,
      account_holder_name,
      account_type,
      account_number,
      bank_holder_type,
      card_address,
    } = this.state;

    const schema = yup.object().shape({
      bank_name: yup.string().required("Please enter correct value !"),
      routing_number: yup
        .string()
        .required("Please enter correct value !")
        .min(9, "Total number of digits should be 9")
        .max(9, "Total number of digits should be 9"),
      account_holder_name: yup
        .string()
        .nullable()
        .required("Please enter correct value !")
        .max(20, "Length should not greater than 20"),
      account_number: yup
        .string()
        .nullable()
        .required("Please enter correct value !")
        .max(15, "Length should not greater than 15"),
      account_type: yup.string().required("Please enter correct value !"),
      bank_holder_type: yup.string().required("Please enter correct value !"),
      card_address: yup.object().shape({
        address: yup.string().required("Address is required"),
        state: yup.string().required("State is required"),
        city: yup.string().required("City is required"),
        zip_code: yup.string().required("Zipcode is required"),
      }),
    });
    const data = {
      card_address,
      bank_name,
      routing_number,
      account_holder_name,
      account_number,
      account_type,
      bank_holder_type,
    };

    schema
      .validate(data, { abortEarly: false })
      .then(() => {
        this.setState({ errors: {}, is_btn_active: true });
        this.addNewACHcard();
      })
      .catch((error) => {
        let err_data = {};
        map(error?.inner, (item) => {
          err_data[item.path] = item.message;
        });
        this.setState({
          errors: err_data,
          loader: false,
          is_btn_active: false,
        });
      });
  };

  // Load Stax
  loadStax = () => {
    this.setState({ is_edit_info: true, can_edit: false });
    const { stax_public_apikey } = this.state;

    if (stax_public_apikey) {
      const FattJs = window.FattJs;
      const fattJs = new FattJs(stax_public_apikey, {
        number: {
          id: "card-number",
          placeholder: "Card Number",
          style:
            "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;",
        },
        cvv: {
          id: "card-cvv",
          placeholder: "CVV",
          style:
            "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;",
        },
      });
      fattJs
        .showCardForm()
        .then((handler) => {
          console.log("form loaded", handler);
        })
        .catch((err) => {
          console.error("error occur", err);
        });
      this.fattJs = fattJs;
    } else {
      message.error(
        "Error occur while loading stax. please contact to admin.",
        10
      );
    }
  };

  render() {
    let {
      is_edit_info,
      loader,
      card_holder_name,
      can_edit,
      errors,
      role,
      showAddAddressView,
      payment_method,
      bank_name,
      routing_number,
      account_holder_name,
      account_number,
      account_type,
      bank_holder_type,
      card_list,
    } = this.state;

    return (
      <div className="billing_wrapper">
        <div className="container">
          <div className="row">
            {this.renderCardList()}
            {card_list?.length < 5 && (
              <div className="col-md-4">
                <div className="blank_box">
                  <div className="details">
                    <h3>Add another credit card or ACH payment</h3>
                    <button
                      className="btn btn--secondary"
                      onClick={() => {
                        this.loadStax();
                      }}
                    >
                      Add Payment Method
                    </button>
                  </div>
                  <img src={peeking_doodle} alt="" />
                </div>
              </div>
            )}
          </div>
        </div>
        <Modal
          className="new_card_pupup"
          visible={is_edit_info}
          footer={[
            <Button
              key="cancel"
              className="btn btn-outline--primary"
              onClick={() => {
                this.setState({
                  errors: {},
                  is_edit_info: false,
                  can_edit: false,
                  card_holder_name: "",
                  card_address: {},
                  bank_name: "",
                  routing_number: "",
                  account_holder_name: "",
                  account_number: "",
                  account_type: "",
                  bank_holder_type: "",
                  payment_method: "",
                });
              }}
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              className="btn btn--secondary"
              onClick={() => {
                this.handleValidate();
              }}
              disabled={payment_method === ''}
            >
              {payment_method === "credit_card" ? "Add Card" : payment_method === 'ach' ? 'Add ACH' : "Add"}
            </Button>,
          ]}
        >
          <div className="moday_body">
            <div className="field-group">
              <label>
                Payment Method <sup>*</sup>
              </label>
              <div className="mb-10">
                <Select
                  placeholder="Select"
                  style={{width: '100%'}}
                  value={payment_method || undefined}
                  onChange={(e) => {
                    this.setState({ payment_method: e, errors: {} });

                    if(e === 'credit_card')
                    {
                      this.loadStax();
                    }
                  }}
                >
                  {map(payment_methods, (item, index) => {
                    return (
                      <Option key={index} value={item.key}>
                        {item.value}
                      </Option>
                    );
                  })}
                </Select>
              </div>
            </div>
            {payment_method === "credit_card" && (
              <>
                <h4 className="modal_title">
                  {!can_edit ? "Add Credit Card" : "Edit Credit Card"}
                </h4>
                <div className="billing_form">
                  <div className="billing_control">
                    <div className="single_control">
                      <input
                        type="text"
                        value={card_holder_name || ""}
                        onChange={(e) => {
                          this.setState({
                            card_holder_name: e.target.value,
                          });
                        }}
                        className="form--control"
                        placeholder="Cardholder Name"
                      />
                      {errors["card_holder_name"] ? (
                        <label className="new_err_msg">
                          <i className="las la-info-circle"></i>{" "}
                          {errors["card_holder_name"]}
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {!can_edit ? (
                    <React.Fragment>
                      <div className="billing_control">
                        <div className="single_control">
                          <div
                            id="card-number"
                            className="form--control"
                            style={{
                              height: 50,
                              border: "2px solid #E6E6E6",
                              backgroundColor: "#ffffff",
                            }}
                          ></div>
                          {errors && errors["card_number"] ? (
                            <label className="new_err_msg">
                              <i className="las la-info-circle"></i>{" "}
                              {errors["card_number"]}
                            </label>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="billing_control">
                        <div className="multi_control mr-2">
                          <input
                            type="text"
                            className="form--control mr-2"
                            placeholder="MM"
                            maxLength={2}
                            inputMode="numeric"
                            onPaste={(event) => {
                              if (
                                event.clipboardData
                                  .getData("Text")
                                  .match(/[^\d]/)
                              ) {
                                event.preventDefault();
                              }
                            }}
                            onKeyPress={(e) => {
                              const pattern = /[0-9]/;
                              const inputChar = String.fromCharCode(e.charCode);
                              if (!pattern.test(inputChar)) {
                                // invalid character, prevent input
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              this.setState({
                                card_expiry_month: e.target.value,
                              });
                            }}
                          />
                          {errors && errors["card_expiry_month"] ? (
                            <label className="new_err_msg">
                              <i className="las la-info-circle"></i>{" "}
                              {errors["card_expiry_month"]}
                            </label>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="multi_control">
                          <input
                            type="text"
                            className="form--control mr-2"
                            placeholder="YYYY"
                            maxLength={4}
                            inputMode="numeric"
                            onPaste={(event) => {
                              if (
                                event.clipboardData
                                  .getData("Text")
                                  .match(/[^\d]/)
                              ) {
                                event.preventDefault();
                              }
                            }}
                            onKeyPress={(e) => {
                              const pattern = /[0-9]/;
                              const inputChar = String.fromCharCode(e.charCode);
                              if (!pattern.test(inputChar)) {
                                // invalid character, prevent input
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              this.setState({
                                card_expiry_year: e.target.value,
                              });
                            }}
                          />
                          {errors && errors["card_expiry_year"] ? (
                            <label className="new_err_msg">
                              <i className="las la-info-circle"></i>{" "}
                              {errors["card_expiry_year"]}
                            </label>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="billing_control">
                        <div className="single_control">
                          <div
                            id="card-cvv"
                            className="form--control"
                            style={{
                              height: 50,
                              border: "2px solid #E6E6E6",
                              backgroundColor: "#ffffff",
                            }}
                          ></div>
                        </div>
                      </div>
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                </div>
                <div className="address">
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ margin: "0px" }}>Billing Address</span>

                      {/* <a href="/#" className="action_link primary" style={{margin: '2px'}} onClick={(e) => { e.preventDefault(); this.toggleAddAddress(true)}}><b>Add New Address</b></a> */}
                    </div>
                  </div>
                  {errors["card_address.address"] ||
                  errors["card_address.city"] ||
                  errors["card_address.state"] ||
                  errors["card_address.zip_code"] ? (
                      <label className="new_err_msg">
                        <i className="las la-info-circle"></i>{" "}
                        {"Billing address is required"}
                      </label>
                    ) : (
                      ""
                    )}
                  {role.includes("commercial_customer")
                    ? this.renderCommercialServiceOrder()
                    : this.renderServiceOrder()}
                  {showAddAddressView && (
                    <AddAddress
                      onCancel={this.toggleAddAddress}
                      onAdd={this.onAddAddress}
                    />
                  )}
                  {/* <a href="/#" className="action_link" onClick={(e) => { e.preventDefault(); }}> Add New Address</a> */}
                </div>
              </>
            )}
            {payment_method === "ach" && (
              <>
                <h4 className="modal_title">
                  {!can_edit ? "Add ACH Payment" : "Edit ACH Payment"}
                </h4>
                <div className="billing_form">
                  <div className="billing_control">
                    <div className="single_control">
                      <input
                        type="text"
                        value={bank_name || ""}
                        onChange={(e) => {
                          this.setState({
                            bank_name: e.target.value,
                          });
                        }}
                        className="form--control"
                        placeholder="Bank Name"
                      />
                      {errors["bank_name"] && (
                        <label className="new_err_msg">
                          <i className="las la-info-circle"></i>{" "}
                          {errors["bank_name"]}
                        </label>
                      )}
                    </div>
                  </div>
                  <div className="billing_control">
                    <div className="single_control">
                      <input
                        type="text"
                        value={account_holder_name || ""}
                        onChange={(e) => {
                          this.setState({
                            account_holder_name: e.target.value,
                          });
                        }}
                        className="form--control"
                        placeholder="Account Holder Name"
                      />
                      {errors["account_holder_name"] && (
                        <label className="new_err_msg">
                          <i className="las la-info-circle"></i>{" "}
                          {errors["account_holder_name"]}
                        </label>
                      )}
                    </div>
                  </div>
                  <div className="billing_control" style={{gap: "10px"}}>
                    <div className="multi_control" style={{width: '49%'}}>
                      <input
                        type="text"
                        value={routing_number || ""}
                        onChange={(e) => {
                          this.setState({
                            routing_number: e.target.value,
                          });
                        }}
                        className="form--control"
                        placeholder="Routing Number"
                      />
                      {errors["routing_number"] && (
                        <label className="new_err_msg">
                          <i className="las la-info-circle"></i>{" "}
                          {errors["routing_number"]}
                        </label>
                      )}
                    </div>
                    <div className="multi_control" style={{width: '49%'}}>
                      <input
                        type="text"
                        value={account_number || ""}
                        onChange={(e) => {
                          this.setState({
                            account_number: e.target.value,
                          });
                        }}
                        className="form--control"
                        placeholder="Account Number"
                      />
                      {errors["account_number"] && (
                        <label className="new_err_msg">
                          <i className="las la-info-circle"></i>{" "}
                          {errors["account_number"]}
                        </label>
                      )}
                    </div>
                  </div>
                  <div className="billing_control">
                    <div className="multi_control" style={{width: '50%'}}>
                      <label>Account Type</label>
                      <Radio.Group
                        name="account_type"
                        style={{ display: "flex", flexDirection: "column" }}
                        value={account_type}
                        onChange={(e) =>
                          this.setState({ account_type: e.target.value })
                        }
                      >
                        <Space direction="horizontal">
                          <Radio className="billing_radio" value={"checking"}>
                            Checking
                          </Radio>
                          <Radio className="billing_radio" value={"savings"}>
                            Saving
                          </Radio>
                        </Space>
                      </Radio.Group>
                      {errors["account_type"] ? (
                        <label className="new_err_msg">
                          <i className="las la-info-circle"></i>{" "}
                          {errors["account_type"]}
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="multi_control" style={{width: '50%'}}>
                      <label>Bank Holder Type</label>
                      <Radio.Group
                        name="bank_holder_type"
                        style={{ display: "flex", flexDirection: "column" }}
                        value={bank_holder_type}
                        onChange={(e) =>
                          this.setState({ bank_holder_type: e.target.value })
                        }
                      >
                        <Space direction="horizontal">
                          <Radio className="billing_radio" value={"personal"}>
                            Personal
                          </Radio>
                          <Radio className="billing_radio" value={"business"}>
                            Business
                          </Radio>
                        </Space>
                      </Radio.Group>
                      {errors["bank_holder_type"] ? (
                        <label className="new_err_msg">
                          <i className="las la-info-circle"></i>{" "}
                          {errors["bank_holder_type"]}
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="address">
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ margin: "0px" }}>Billing Address</span>
                    </div>
                  </div>
                  {errors["card_address.address"] ||
                  errors["card_address.city"] ||
                  errors["card_address.state"] ||
                  errors["card_address.zip_code"] ? (
                      <label className="new_err_msg">
                        <i className="las la-info-circle"></i>{" "}
                        {"Billing address is required"}
                      </label>
                    ) : (
                      ""
                    )}
                  {role.includes("commercial_customer")
                    ? this.renderCommercialServiceOrder()
                    : this.renderServiceOrder()}
                  {showAddAddressView && (
                    <AddAddress
                      onCancel={this.toggleAddAddress}
                      onAdd={this.onAddAddress}
                    />
                  )}
                  {/* <a href="/#" className="action_link" onClick={(e) => { e.preventDefault(); }}> Add New Address</a> */}
                </div>
              </>
            )}
          </div>
        </Modal>
        {loader ? (
          <div className="loader_wrapper">
            <div className="loader07"></div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default BillingInfo;
